<template>
  <div class="sezione contatto" style="" >


        <div class="row pad row-head">
          <div class="col s12 white">&#160;</div>
        </div>
        <div class="row vpad pad row-table-firstcol yo-text-s yo-spacing-xs">


          <div class="col s12 " style="font-weight:normal;">
                  

        <el-menu default-active="-1" class="" :router="true" mode="vertical">
         <el-menu-item index="/contatto-edit">MODIFICA PROFILO</el-menu-item>
         <el-menu-item index="/contatto-password">CAMBIA PASSWORD</el-menu-item>
         <!-- <el-menu-item index="/contatto-rinnovo">RINNOVO</el-menu-item> -->
         </el-menu>

          </div>

        </div>


        <div class="row pad row-head">
          <div class="col s12 white">HELP - AIUTO</div>
        </div>
        <div class="row vpad pad row-table-firstcol yo-text-s yo-spacing-xs">


          <div class="col s12 " style="font-weight:normal;">
            Per eventuali problemi contattare la Segreteria Amministrativa.
            <br />
            Sarete contattati entro 48 ore.
          </div>

 
          <div class="col s4 yo-height-full">Email</div>
          <div class="col s8"><a href="segreteria@sip.it">segreteria@sip.it</a></div>
        </div>



        <div class="row pad row-head">
          <div class="col s12 white">RECAPITI</div>
        </div>
        <div class="row vpad pad row-table-firstcol yo-text-s yo-spacing-xs ">
          <div class="col s4 yo-height-full">Email</div>
          <div class="col s8">{{$socio.contatto.row.email | sevuoto('n.d.') }}</div>

          <div class="col s4 yo-height-full">Cellulare</div>
          <div class="col s8">{{$socio.contatto.row.cellulare | sevuoto('n.d.') }}</div>
        </div>


        <div class="row pad row-head">
          <div class="col s12 white">DATI ANAGRAFICI</div>
        </div>
        <div class="row vpad pad row-table-firstcol yo-text-s yo-spacing-xs">


          <div class="col s4 yo-height-full">Data Nascita</div>
          <div class="col s8">{{$socio.contatto.row.natoil | data('DD-MM-YYYY')}}</div>

          <div class="col s4 yo-height-full">Città Nascita</div>
          <div class="col s8">{{$socio.contatto.row.natoa | sevuoto('n.d.') }} <span v-if="$socio.contatto.row.natonazione=='ITA'">({{$socio.contatto.row.natoprovincia}})</span></div>
          <div class="col s4 yo-height-full">Nazione Nascita</div>
          <div class="col s8">{{$socio.contatto.row.natonazione | sevuoto('n.d.') }}</div>

          <div class="col s4 yo-height-full">Sesso</div>
          <div class="col s8">{{$socio.contatto.row.sesso | sevuoto('n.d.') }}</div>

          <div class="col s4 yo-height-full">CF</div>
          <div class="col s8">{{$socio.contatto.row.codicefiscale | sevuoto('n.d.') }}</div>
        </div>

        <div class="row pad row-head">
          <div class="col s12 white">RESIDENZA</div>
        </div>
        <div class="row vpad pad row-table-firstcol yo-text-s yo-spacing-xs">
          <div class="col s4 yo-height-full">IND.</div>
          <div class="col s8  yo-height-full">{{$socio.contatto.row.address | sevuoto('n.d.') }}</div>

          <div class="col s4 yo-height-full">Città</div>
          <div class="col s8">{{$socio.contatto.row.citta | sevuoto('n.d.') }}</div>

          <div class="col s4 yo-height-full">CAP</div>
          <div class="col s8">{{$socio.contatto.row.cap | sevuoto('n.d.') }}</div>

          <div class="col s4 yo-height-full">Nazione</div>
          <div class="col s8">{{$socio.contatto.row.nazione | sevuoto('n.d.') }}</div>
        </div>

        <div class="row pad row-head">
          <div class="col s12 white">LAVORO</div>
        </div>
        <div class="row vpad pad row-table-firstcol yo-text-s yo-spacing-xs">
          <div class="col s4 yo-height-full">Ente</div>
          <div class="col s8">{{$socio.contatto.row.ente | sevuoto('n.d.') }}</div>

          <div class="col s4 yo-height-full">UO</div>
          <div class="col s8">{{$socio.contatto.row.unitaoperativa | sevuoto('n.d.') }}</div>

          <div class="col s4 yo-height-full">Città</div>
          <div class="col s8">{{$socio.contatto.row.workcitta | sevuoto('n.d.') }}</div>

          <div class="col s4 yo-height-full">CAP</div>
          <div class="col s8">{{$socio.contatto.row.workcap | sevuoto('n.d.') }}</div>

          <div class="col s4 yo-height-full">Nazione</div>
          <div class="col s8">{{$socio.contatto.row.worknazione | sevuoto('n.d.') }}</div>
        </div>



  
   
</div>
</template>

<script>
export default {
  components: {
  },
  created () {

  }
}
</script>